import "./style.scss";
import Tabs from "@/src/components/Tabs/Tabs";
import { universityProgramsTabs, universityProgramsEducation, universityProgramsQualification } from "@/src/constants/university-programs";
import { useState } from "react";
import UniversityProgramsCardsMob from "./UniversityProgramsCardsMob/UniversityProgramsCardsMob";

const UniversityProgramsMob = () => {
  const [currentTab, setCurrentTab] = useState<string>("bachelor");

  return (
    <div className="university-programs-mob container">
      <div className="university-programs-mob-header">
        <Tabs title="Программы" tabs={universityProgramsTabs} currentTab={currentTab} setCurrentTab={setCurrentTab} />
      </div>
      {currentTab === "bachelor" && <UniversityProgramsCardsMob content={universityProgramsEducation} currentTab={currentTab} />}
      {currentTab === "masters" && <UniversityProgramsCardsMob content={universityProgramsQualification} currentTab={currentTab} />}
    </div>
  );
};

export default UniversityProgramsMob;
